import i18n from '@/i18n'
export default ({
    request
}) => ({
    SYS_MENU_HEAD_LOAD() {
        return request({
            url: '/digitalCenter/menuRole/menuHeader',
            method: 'post',
            data: {
                curLanguage: i18n.locale
            }
        })
    },
    SYS_MENU_SIDE_LOAD(funcId) {
        return request({
            url: '/sys/function/menuSide',
            method: 'post',
            data: {
                pid: funcId,
                curLanguage: i18n.locale
            }
        })
    }
})